import { saveAs } from 'file-saver';

const Submit = (data) => {
  const handleDownload = () => {
    const newData = JSON.parse(data.data)
    const dataToWrite = newData.records.map(record => `"${record.QualifiedApiName}","${record.DataType}"\n`)
    dataToWrite.unshift("Field Name,Data Type\n")
    dataToWrite[dataToWrite.length - 1].trim()
    const file = new Blob([...dataToWrite], { type: 'application/vnd.ms-excel' });
    saveAs(file, 'fields.csv');
  };

  return (
    <button onClick={handleDownload}>
      Submit
    </button>
  );
};

export default Submit;